import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { IInfo, Info } from '../../../../../core/common';
import { IMacro, IMasterData, Macro, MasterData } from '../../../../../core/models';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CommonService } from '../../../../../core/services/common.service';
import { HelperService } from '../../../../../core/services/helper.service';
import { MacroService } from '../../../../../core/services/macro.service';
import { UserService } from '../../../../../core/services/user.service';

@Component({
  selector: 'app-add-new-macro',
  templateUrl: './add-new-macro.component.html',
  styleUrls: ['./add-new-macro.component.scss']
})
export class AddNewMacroComponent implements OnInit {

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private macroService: MacroService,
    private router: Router,
    private helper: HelperService,
    private appNotifyService: AppNotifyService,
    private commonService: CommonService  ) { }

  ngOnInit(): void {
  }

  
  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  addMacro: IMacro = new Macro();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();

  get types(): MasterData[] {
    return this.macroService.types;
  }
  get targets(): MasterData[] {
    return this.macroService.targets;
  }
  

  validateForm(): boolean {
    return true;
  }

  targetValueChange(event: IMasterData, addMacro: IMacro): void {
    if (this.addMacro.selectedtarget) {
      this.addMacro.target = this.addMacro.selectedtarget.name;
    }
    
  }
  targetSelectionChange(event: IMasterData, addMacro: IMacro): void {
    if (this.addMacro.selectedtarget) {
      this.addMacro.target = this.addMacro.selectedtarget.name;
    }
  }

  typeValueChange(event: IMasterData, addMacro: IMacro): void {
    
    if (this.addMacro.selectedType) {
      this.addMacro.type = this.addMacro.selectedType.name;
    }

  }
  typeSelectionChange(event: IMasterData, addMacro: IMacro): void {

    if (this.addMacro.selectedType) {
      this.addMacro.type = this.addMacro.selectedType.name;
    }
  }

  addMacroToSave(): void {
    this.isSubmitted = true;

    console.log(this.addMacro);
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;

    this.macroService.add(this.addMacro).subscribe((response) => {
      console.log(response);
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }

      this.addMacro = new Macro();
    })
  }
}
